<template>
  <ModalBase @close-modal="closeModal">
    <div v-if="account.stripeCustomerId">
      <div class="popup__edit--title">
        {{
          $t('admins.limitMessage1', {
            plan: plan.type,
            maxCreators: plan.maxCreators
          })
        }}
      </div>
      <div class="popup__close" @click="closeModal">
        <span class="glicon-close-large"></span>
      </div>
      <div class="popup__text">
        {{ $t('admins.limitMessage2') }}
      </div>
      <div class="popup__buttons">
        <gl-button
          id="admin.payment-submit"
          color-primary
          :type="'button'"
          :text="$t('actions.seePlanesAndPrices')"
          @onClick="launchCustomerPortal"
        >
        </gl-button>
      </div>
    </div>
    <div v-else>
      <div class="popup__edit--title">
        {{
          $t('admins.limitMessage1', {
            plan: plan.type,
            maxCreators: plan.maxCreators
          })
        }}
      </div>
      <div class="popup__close" @click="closeModal">
        <span class="glicon-close-large"></span>
      </div>
      <div class="popup__text">
        {{ $t('admins.limitMessage3') }}
      </div>
      <div class="popup__buttons">
        <gl-button
          id="admin.btn-contact"
          color-primary
          :type="'button'"
          :text="$t('subscriptions.planData.contact')"
          @onClick="contact"
        >
        </gl-button>
      </div>
    </div>
  </ModalBase>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import ModalBase from './ModalBase.vue';
import paymentsService from '@/services/payments.service';

export default {
  name: 'AdminLimitModal',
  components: { ModalBase },
  computed: {
    ...mapState({
      account: (state) => state.distributors.distributorData,
      plan: (state) => state.subscriptions.planData
    })
  },
  methods: {
    ...mapMutations(['SET_ADMIN_LIMIT_ERROR']),
    closeModal() {
      this.SET_ADMIN_LIMIT_ERROR(false);
    },
    async launchCustomerPortal() {
      try {
        const referrer = this.$route.query.referrer ? atob(this.$route.query.referrer) : null;
        const { data: session } = await paymentsService.createCustomerPortalSession(
          this.account.stripeCustomerId,
          referrer
        );
        window.top.location.href = session.url;
        return session;
      } catch (error) {
        console.error(error);
      }
    },
    contact() {
      const contactUrl = this.$t('subscriptions.planData.contactUrl');
      window.open(contactUrl);
    }
  }
};
</script>
